import React from "react";

export default function Policy() {
    return (
        <div className="border-4 mt-23 mx-8 sm:mx-16">
            <h1 className="text-xl md:text-3xl text-center p-2 font-bold">წესები, პირობები და მონაცემთა დაცვა</h1>
            <div className="mx-12">
                <ol className="pb-4">
                    <li>1. შესავალი </li>
                    <li className="pl-4">
                        1.1. წინამდებარე ხელშეკრულება საქართველოს
                        კანონმდებლობის შესაბამისად არეგულირებს ურთიერთობას
                        საგანმანათლებლო პორტალ www.aservice.netlify.app-სა (შემდგომში &quot;პორტალი&quot;/ &quot;მიმწოდებელი&quot;)
                        და მის მომხმარებელს (შემდგომში &quot;მომხმარებელი&quot;) შორის (კოლექტიურად &quot;მხარეები&quot;).
                        <br />1.2 მომხმარებელი უფლებამოსილია, ნების თავისუფლების საფუძველზე,
                        უარი განაცხადოს წარმოდგენილ წესებსა და პირობებზე, რაც ნიშნავს პორტალის
                        მომსახურებით სარგებლობაზე უარის თქმას.
                        <li className="pl-4">1.2.1 მომხმარებელის ინფორმაცია დაცულია „პერსონალურ მონაცემთა
                            დაცვის შესახებ&quot;საქართველოს კანონის შესაბამისად. მომხმარებელმა წერილობით უნდა
                            დააფიქსიროს მეილზე offers.accservice@gmail.com რომ სურს თავისი ანგარიშის გაუქმება,
                            რის შემდეგაც 24 საათის მანძილზე სრულად გაუქმდება მომხმარებლის ანგრიში პორტალზე და
                            პერმანენტულად წაიშლება მომხმარებელთან დაკავშირებული ყველანაირი ინფორმაცია.
                        </li>1.3. წინამდებარე ხელშეკრულების წესებისა და პირობების დაცვით,
                        მომხმარებელი აფორმებს შეკვეთას, ხოლო პორტალი მას გადასცემს შეთანხმებულ
                        სერვისის შეთანხმებული საზღაურის სანაცვლოდ. </li>
                </ol>
                <ol className="pb-4"><li>3. შეკვეთის განხორციელება : </li>
                    <li className="pl-4">3.1. მომხმარებელი ვებგვერდზე ირჩევს სასურველ სერვისს და გამოხატავს მისი
                        შესყიდვის ნებას. მომხმარებელს აქვს შესაძლებლობა სერვისი შეიძინოს შემდეგი ფორმით:
                        <li>3.1.3. სატელეფონო ზარის განხორციელების გზით
                            <li className="pl-4">3.1.3.1. სატელეფონო გზით შესყიდვის ნების გამოხატვისას ზარი იწერება. </li>
                        </li>
                        <li>3.1.4. იმეილის საშუალებით
                            <li className="pl-4">3.1.4.1. იმეილის საშუალებით შეკვეთის განხორციელების
                                შემთხვევაში მიმოწერა ინახება პორტალის მიერ.</li>
                        </li>
                        {/* </li> */}
                        <li>3.2. მომხმარებელი უფლებამოსილია შეძენილი სერვისი დაუბრუნოს
                            მიმწოდებელს და მოითხოვოს მიმწოდებლისგან სერვისის ღირებულების
                            ანაზღაურება სერვისის მიღებიდან 1 (ერთი) საათის განმავლობაში, იმ
                            შემთხვევაში თუ შეძენილი პროდუქტი არ აკმაყოფილებს პორტალზე განთავსებულ
                            პროდუქტის აღწერას. 3.3
                            მომხმარებელი უფლებამოსილია მოითხოვოს
                            სერვისის ღირებულების ანაზღაურება, თუ
                            არ მოხდება სერვისის დროული მიწოდება. </li>
                    </li>
                </ol>
                <ol className="pb-4">
                    <li>4. მიწოდება</li>
                    <li className="pl-4">4.1. მომხმარებლის მიერ
                        შეკვეთის გაფორმებისა და ღირებულების გადახდის შემდეგ,
                        ინტერნეტმაღაზია ვალდებულია, გადასცეს მომხმარებელს შეთანხმებული სერვისი,
                        რომელიც სრულად აკმაყოფილებს პორტალზე განთავსებულ სერვისის აღწერას
                        ;<br />4.2. მომხმარებლისთვის სერვისის მიწოდება ხდება პორტალზე<br />
                        4.3. სერვისის მიწოდება ხდება შეკვეთიდან მაქსიმუმ 1 სამუშაო დღეში.</li>
                </ol>
                <ol className="pb-4"><li>5. გადახდა </li>
                    <li className="pl-4">5.1. სერვისის შესყიდვაზე ნების გამოხატვის შემდეგ მომხმარებე
                        იხდის სერვისის საფასურს, რომელიც მითითებული არის ვებგვერდზე.
                        <br />5.2. ანგარიშსწორება ხორციელდება, მომხმარებლის მიერ სერვისის შეკვეთისას მის
                        მიერ შერჩეული ერთ-ერთი მეთოდით:
                        <li className="pl-4">5.2.1. ონლაინ, უნაღდო
                            ანგარიშსწორებით, ერთიანი გადახდით, რომელიც ხორციელდება ვებგვერდის მეშვეობით
                            ან საბანკო გადარიცხვით;
                            <li className="pl-4">5.2.1.1. უნაღდო ანგარიშსწორების ვალდებულება შესრულებულად
                                ითვლება მიმწოდებლის საბანკო ანგარიშზე თანხის აღრიცხვის მომენტიდან. </li>
                            <li>5.2.2. ონლაინ, უნაღდო ანგარიშსწორებით, ერთიანი გადახდით, რომელიც ხორციელდე
                                საბანკო გადარიცხვით;
                                <li className="pl-4">5.2.2.1. საბანკო გადარიცხვის ვალდებულება შესრულებულად
                                    თვლება მიმწოდებლის საბანკო ანგარიშზე თანხის აღრიცხვის მომენტიდან. </li>
                            </li>
                        </li>
                        <li>5.3. იმ შემთხვევაში, თუ მომხმარებელი აფორმებს შეკვეთას მომხმარებლის
                            ანგარიშის მეშვეობით, იგი გადახდის მეთოდს აფიქსირებს ვებგვერდზე. </li>
                    </li>
                </ol>
                <ol className="pb-4">
                    <li>6. მომხმარებლის პრეტენზიები
                    </li>
                    <li className="pl-4">6.1. იმ შემთხვევაში, თუ კი მიწოდებული
                        სერვისი განსხვავდება პორტალზე მოცემული პროდუქტის აღწერისგან,
                        მიმწოდებელი ვალდებულია მომხმარებელს დაუბრუნოს გადახდილი თანხა 3.2 პუქნტის შესაბამისად.
                        <br />6.2. იმ შემთხვევაში, თუ კი მიწოდებული სერვისი არ შეესაბამება მომხმარებლის სურვილს
                        მომხმარებლის ბრალით (მაგალითად, მომხმარებლის შეცდომის შემთხვევაში), მომხმარებლის
                        შეუძლია შეუკვეთოს სხვა მსგავსი პროდუქტი, ასეთის არსებობის შემთხვევაში. გადასახდელი თანხა,
                        ასევე, შეიცვლება იმ სერვისის ღირებულებათა სხვაობის მიხედვით, რომელიც მომხმარებელმა
                        შეუკვეთა და რომლის შეკვეთაც მომხმარებელს სურდა.<br />6.3. იმ შემთხვევაში,
                        თუ კი მიწოდებული სერვისი არ შეესაბამება შეთანხმებულს მომხმარებლის ბრალით
                        (მაგალითად, მომხმარებლის შეცდომის შემთხვევაში), და იგი უარს აცხადებს მიიღოს
                        ის სერვისიც, რომლის შეკვეთაც ჰქონდა განზრახული, იგი ვალდებულია გადაიხადოს
                        პირგასამტეხლო გადახდილი თანხის 50%-ის ოდენობით (თუ მას უკვე აქვს გადახდილი
                        სერვისის ღირებულება იგი მას უბრუნდება ამ მუხლით გათვალისწინებული გადასახადების
                        გამოკლებით).<br />6.4. მომხმარებელი ვალდებულია სერვისის
                        მიღებიდან 1 საათის განმავლობაში შეამოწმოს არის თუ არა მის მიერ
                        მიღებული სერვისი ის, რაც მან შეუკვეთა/რისი შეკვეთაც მას სურდა,
                        სხვა შემთხვევაში, იგი არ არის უფლებამოსილი ისარგებლოს წინამდებარე ხელშეკრულების
                        6.1., 6.2., 6.3. პუნქტებით გათვალისწინებული უფლებებით.
                        <br />6.5. მომხმარებლისათვის სერვისის გადაცემისთანავე მხარეთა
                        შორის ფორმდება მიღება-ჩაბარების აქტი, რომლითაც დადასტურდება
                        გადაცემული ნივთის უნაკლოობა. მიღება-ჩაბარების აქტი ძალაში შედის,
                        თუ კი მისი გაფორმებიდან 1 საათის განმავლობაში მომხმარებელი წერილობით ა
                        რ შეატყობინებს საგანმანათლებლო პორტალს სერვისის ნაკლის შესახებ.<br />
                        6.6 მიმწოდებელი ვალდებულია მომხმარებლის პრეტენზიების შეტყობინების მიღებიდან 3
                        (სამი) დღის ვადაში განიხილოს პრეტენზია და მიიღოს შესაბამისი გადაწყვეტილება 6.1., 6.2., 6.3.
                        პუნქტებით გათვალისწინებული უფლებებით.<br />
                        6.7. მომხმარებელი არ არის უფლებამოსილი დააბრუნოს
                        ან გადაცვალოს მიღებული სერვისი ან მოითხოვოს მის
                        მიერ გადახდილი საფასურის დაბრუნება, გარდა წინამდებარე ხელშეკრულებით
                        გათვალისწინებული შემთხვევებისა. </li>
                </ol>
                <ol className="pb-4"><li>7. საავტორო უფლებები </li>
                    <li className="pl-4">7.1. ვებგვერდზე განთავსებულ ნებისმიერ
                        მასალაზე, მათ შორის ვიზუალურ თუ აუდიო მასალაზე, ფოტოზე,
                        ვიდეოზე და ა.შ. საავტორო უფლებები ეკუთვნის მიმწოდებელს. მომხმარებელი
                        არ არის უფლებამოსილი გამოიყენოს, გაავრცელოს, ან ისარგებლოს მითითებული
                        მასალით მიმწოდებლის წინასწარი წერილობითი თანხმობის გარეშე, ან სხვა რაიმე ფორმით
                        დაარღვიოს მიმწოდებლის საავტორო უფლებები. </li>
                </ol>
                <ol className="pb-4"><li>8. მხარეთა პასუხისმგებლობა და პასუხისმგებლობისგან გათავისუფლება </li>
                    <li className="pl-4">8.1. მხარეებს ეკისრებათ პასუხისმგებლობა დაკისრებული
                        ვალდებულებების შეუსრულებლობის ან არაჯეროვნად შესრულებისათვის ამ ხელშეკრულებისა
                        და მოქმედი კანონმდებლობის შესაბამისად;<br />8.2. მხარეები თავისუფლდებიან
                        პასუხისმგებლობისგან, თუ მათი მხრიდან ვალდებულების დარღვევა გამოწვეული
                        არის დაუძლეველი ძალის მოქმედებით (ფორს-მაჟორი) ან ისეთი გარემოებით,
                        რომლის გათვალისწინება და აღკვეთა მხარეების ძალებს აღემატებოდა;
                        <li className="pl-4">8.2.1. ხელშეკრულების მიზნებისთვის პასუხისმგებლობისგან
                            გამათავისუფლებელ გარემოებებად ჩაითვლება, სტიქიური მოვლენები, გაფიცვები,
                            საბოტაჟი ან სხვა საწარმოო არეულობა, სამოქალაქო მღელვარება, ომი, სამხედრო
                            მოქმედებები, ბლოკადა, აჯანყება, მიწისძვრა, მეწყერების ჩამოწოლა, ეპიდემია,
                            წყალდიდობა და სხვა მსგავსი მოვლენები, რომელიც არ ექვემდებარება მხარეთა
                            კონტროლს და რომელთა თავიდან აცილებაც მათ მიერ შეუძლებელია;<br />8.2.2.
                            ხელშეკრულებების პირობების დარღვევა ფორსმაჟორული გარემოებების დადგომის გამო ა
                            რ გამოიწვევს საჯარიმო სანქციების გამოყენებას;</li>
                    </li></ol>

                <ol className="pb-4">
                    <li>9. ხელშეკრულების ძალაში შესვლა და შეწყვეტა. </li>
                    <li className="pl-4">9.1. ხელშეკრულება ძალაში შედის
                        მომხმარებლის მიერ სათანადო წესით, ელექტრონული გზით,
                        მასზე თანხმობის გამოხატვის მომენტიდან და მოქმედებს მხარეთა
                        მიერ ვალდებულების სრულად და ჯეროვნად შესრულებამდე;
                        <br />
                        9.2. წინამდებარე ხელშეკრულების ვადამდე შეწყვეტა შესაძლებელია:
                        <li className="pl-4">9.2.1. მხარეთა მიერ ურთიერთშეთანხმების საფუძველზე ნებისმიერ დროს;</li>
                        <li className="pl-4" >9.2.2. მხარის მიერ ხელშეკრულებით ნაკისრი
                            ვალდებულების უხეში დარღვევის შემთხვევაში, თუ კი მეორე
                            მხარის მიერ დანიშნული დამატებითი გონივრული ვადის ამოწურვის შემდეგაც არ
                            ასრულებს ვალდებულებას ჯეროვნად;
                            <li />
                            <li>   9.2.3. ამ ხელშეკრულებით და/ან
                                კანონმდებლობით გათვალიწინებულ შემთხვევებში.</li>

                        </li> </li>
                </ol>
                <ol className="pb-4"><li>10. დავების გადაწყვეტის წესი : </li>
                    <li className="pl-4">10.1. ნებისმიერი დავა, რაც წარმოიშვება ამ ხელშეკრულებიდან
                        ან ამ ხელშეკრულებასთან კავშირში, მათ შორის ნებისმიერი კითხვა მისი არსებობის,
                        კანონიერების, განმარტების, აღსრულების, დარღვევის ან შეწყვეტის შესახებ უნდა გადაწყდეს
                        მოლაპარაკების გზით;
                        <br />10.2. თუ მოლაპარაკებას აზრი არ აქვს ან თუ მოლაპარაკებამ შედეგი არ
                        გამოიღო, მხარეთა შორის ნებისმიერი დავა, წარმოშობილი წინამდებარე ხელშეკრულებიდან
                        ან მასთან დაკავშირებით, განხილვისა და საბოლოო გადაწყვეტილების მიღების მიზნით გადაეცემა
                        სასამართლოს საქართველოს კანონმდებლობით გათვალისწინებული წესით. </li>
                </ol>
                <ol className="pb-4">
                    <li>11. ზოგადი დებულებები </li>
                    <li className="pl-4">11.1. წინამდებარე ხელშეკრულების რომელიმე მუხლის ბათილად
                        ცნობა ზეგავლენას არ ახდენს ამ ხელშეკრულების დანარჩენი მუხლების ნამდვილობაზე,
                        თუ ხელშეკრულება დაიდებოდა ბათილი პირობის გარეშეც.
                        <br />11.2. ნებისმიერი საკითხი, რომელიც განსაზღვრული არ არის ამ ხელშეკრულებით,
                        წყდება საქართველოს კანონმდებლობის შესაბამისად;
                        <br />11.3. წინამდებარე ხელშეკრულებასთან დაკავშირებული ნებისმიერი
                        შეტყობინება ან სხვა კომუნიკაცია უნდა წარიმართოს წერილობით ა
                        ხელშეკრულების რეკვიზიტებსა და მომხმარებლის ანგარიშში მითითებულ
                        საკომუნიკაციო საშუალებებზე შეტყობინების გაგზავნის ან ნებისმიერი სხვა ფორმით,
                        თუ იგი იძლევა საშუალებას, ადრესატის მიერ შეტყობინების მიღების დამტკიცებისა.</li>
                </ol>
            </div>
        </div>
    )
}